<!-- <div class="custombg fixed-top">
  <app-header></app-header>
  <app-breadcrumb></app-breadcrumb>
</div> -->

<div class="wrapper" >
  <div class="row m-0 pt-3">
    <div class="col-6 p-0">
      <div class="left-half">
        <img src="../../../assets/images/dashboard/CmfIconNew.png" alt="Innova_logo" width="100%" height="100%">
      </div>
    </div>
    <div class="col-6 p-0">
      <div class="right-half">
        <div class="competancy_tiles">
          <div class=" cardscomp" *ngFor="let comp of dataWithCount">
            <div class="skill-competency-tile skill-repo-cards pointer-cursor">
              <div class="comp-header-image" (click)="opensubcompetencypage(comp, $event)"
                [ngStyle]="{background: 'url(' + getImageSrc(comp.title) + ') no-repeat 0 0 / cover'}">
                <i class="fa fa-users user_icon"></i>
                <h4 class="comp-main-header h3 mb-0">{{ comp.title }}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
 